import { Col, Row, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { Modal } from 'antd';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import HeadingBack from '../../../component/HeadingBack';
import { usePermission } from '../../../hooks/usePermission';
import { DashboardServices } from '../../../redux/Services';
import AbhaLinkedFilter from '../AbhaFilter';
import moment from 'moment';
const HipUserInisiated = () => {
    const filename = "User Initiated"
    const [FilteredData, setFilteredData] = useState([]);
    const permission = usePermission("HIP Dashboard", "List");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState({});
    const [limit, setLimit] = useState(100);
    const userInisited = useSelector(state => state.dashboard.UserInisited || []);
    const { mutate: getuserApi, isLoading } = useMutation((data) => dispatch(DashboardServices.fetchuserInisitedApi(data,limit,page)));
    const [raw, setRaw] = useState({});
    const [modal1Open, setModal1Open] = useState(false);

    useEffect(() => {
        getuserApi(filter);
        return () => {}
    }, [filter,limit,page])

    useEffect(() => {
        
        if (userInisited && userInisited.length > 0) {
            var data = [];
            userInisited.forEach((value, index) => {
                var item = {
                        "sno": value?.sno,
                        "id": value?.id,
                        "type": value?.type,
                        "ReferenceName": value?.ReferenceName,
                        "patient_reference": value?.patient_reference,
                        "mobile_no": value?.mobile_no,
                        "dateOfBirth": value?.dateOfBirth,
                        "phr_id": value?.phr_id,
                        "createdAt": value?.createdAt,
                        "updatedAt": value?.updatedAt,
                        };

                data.push(item);
            })
            setFilteredData(data);
        }
        return () => { }
    }, [userInisited])

    const headers = [
        { label: "S.No.", key: "sno" },
        { label: "Log Id", key: "id" },
        { label: "Type", key: "type" },
        { label: "Patient Name", key: "ReferenceName" },
        { label: "Patient Id", key: "patient_reference" },
        { label: "Mobile Number", key: "mobile_no" },
        { label: "Date Of Birth", key: "dateOfBirth" },
        { label: "ABHA Address", key: "phr_id" },
        { label: "Created At", key: "createdAt" },
        { label: "Updated At", key: "updatedAt" },
    ];

    const columns = [{
            title: 'S.No.',
            dataIndex: 'sno',
            key: 'sno',
            className: 'table_first_col',
            render: (value, item, index) => (page - 1) * 100 + index + 1
        },
        {
            title: 'Log Id',
            dataIndex: 'id',
            key: 'abha_card_log_id',
            className: 'table_status_col',

        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            className: 'table_status_col',
        },

        {
            title: 'Patient Name',
            dataIndex: 'ReferenceName',
            key: 'ReferenceName',
            className: 'table_status_col patient',
            render: (value, item, index) => {
                let patientData = JSON.parse(item?.query || "{}")?.demographic;
                return ( <
                    div >

                    { patientData?.name } </div>
                )
            }
        },
        {
            title: 'Patient Reference Id',
            dataIndex: 'patient_reference',
            key: 'ReferenceId',
            className: 'table_status_col patient',
            render: (value, item, index) => {
                let patientData = JSON.parse(item?.request_raw_data || "{}")?.query?.patient_data;
                return ( <
                    span > { patientData?.id } </span>
                )
            }
        },
        {
            title: 'Mobile Number',
            dataIndex: 'mobile_no',
            key: 'mobile_no',
            className: 'text-capitalize',
            render: (value, item, index) => {
                let patientData = JSON.parse(item?.query || "{}")?.demographic;
                return ( <div >

                    { patientData?.mobile_no } </div>
                )
            }
        },

        {
            title: 'Date Of Birth',
            dataIndex: 'ReferenceId',
            key: 'ReferenceId',
            className: 'table_status_col',
            render: (value, item, index) => {
                let patientData = JSON.parse(item?.query || "{}")?.demographic;
                return ( 
                <div>
                    {moment.utc(patientData?.dateOfBirth).format('DD-MM-YYYY') } </div>
                )
            }
        },
        {
            title: 'ABHA Address',
            dataIndex: 'phr_id',
            key: 'phr_id',
            className: 'table_status_col',
            // render: (value, item, index) => {
            //     let patientData = JSON.parse(item?.query || "{}")?.demographic;
            //     return (
            //         <div>

            //             {patientData?.dateOfBirth}
            //         </div>
            //     )
            // }
        },


        {
            title: 'Date Time',
            dataIndex: 'createdAt',
            key: 'Title',
            className: 'abha-link-date',
            render: (value, item, index) => {
                return ( <
                    span >
                    <
                    > { moment.utc(item.createdAt).format('DD-MM-YYYY H:mm:ss') } </> </span>
                )
            }
        },
        // {
        //     title: 'Requested Data',
        //     dataIndex: 'Status',
        //     key: 'Status',
        //     className: 'table_status_col',
        //     render: (value, item, index) => {
        //         return (
        //             <Button className="view-btn" type="primary" onClick={() => { setRaw(JSON.parse(item?.request_raw_data || "{}")); setModal1Open(true) }} > View</Button>
        //         )
        //     }
        // },
        // {
        //     title: 'Response Data',
        //     dataIndex: 'Status',
        //     key: 'Status',
        //     className: 'table_status_col',
        //     render: (value, item, index) => {
        //         return (
        //             <Button className="view-btn" type="primary" onClick={() => { setRaw(JSON.parse(item?.response_raw_data || "{}")); setModal1Open(true) }} > View</Button>
        //         )
        //     }
        // },

    ];
    return ( <
        div >
        <
        Row gutter = {
            [10, 10] }
        align = { "middle" } >
        <
        Col lg = { 3 }
        md = { 24 }
        sm = { 24 }
        xs = { 24 } >
        <
        HeadingBack title = { "User Initiated" }
        subHeading = { `Records ${userInisited?.length || 0}`}
        /> </Col> <
        Col lg = { 19 }
        md = { 12 }
        sm = { 24 }
        xs = { 24 } >
        <
        AbhaLinkedFilter filter = { filter }
        setFilter = { setFilter }
        setPage = { setPage }
        headers={headers} FilteredData={FilteredData} setFilteredData={setFilteredData} filename={filename}
        /> </Col>

        </Row> <
        div className = 'tableResponsive mt-10' >
        <
        Table rowKey = 'Id'
        className = { isLoading ?'table antd_table no_data_found_hide' : 'table antd_table' }
        bordered columns = { columns }
        dataSource = { Array.isArray(userInisited) && userInisited?.length > 0 ?userInisited : [] }
        pagination = {
            {
                current: page,
                pageSize: limit,
                onChange(current, pageSize) {
                    setPage(current);
                },
                hideOnSinglePage: true,
                /* total: totalFaq,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                responsive: true */
            }
        }

        /> <Modal style = {
            {
                top: 20,
            }
        }
        open = { modal1Open }
        onOk = {
            () => setModal1Open(false) }
        onCancel = {
            () => setModal1Open(false) }
        footer = { null } >
        <
        pre > { JSON.stringify(raw, null, 2) } </pre>

        </Modal> </div> </div>
    )
}

export default HipUserInisiated